// extracted by mini-css-extract-plugin
export default {"overRoot":"tenant_overRoot__U2zzB"};